import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterComponent } from './filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
@NgModule({
	declarations: [
		FilterComponent
	],
	imports: [
		CommonModule,
        FormsModule,
		ReactiveFormsModule,
		MatSelectModule,
		MatIconModule,
		MatInputModule,
		MatDatepickerModule
	],
	exports: [
		FilterComponent
	]
})
export class FilterModule { }
